import React, { useState } from 'react';
import { RenewSubscriptionConfirmModal } from './RenewSubscriptionConfirmModal';

export const useRenewSubscriptionConfirmModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((o) => !o);
  const modal = (
    <RenewSubscriptionConfirmModal
      open={isOpen}
      onRenewed={toggle}
      onClose={toggle}
    />
  );

  return [toggle, modal] as const;
};
